import React, { useEffect, useState } from "react";
import { Fade } from "react-awesome-reveal";
import Lottie from "lottie-react";
import Button from "../elements/Button";
import '../assets/css/hero.css';

// Animation imports
import animation1 from "../assets/animations/1.json";
import animation2 from "../assets/animations/2.json";
import animation3 from "../assets/animations/3.json";
import animation4 from "../assets/animations/4.json";
import animation5 from "../assets/animations/5.json";
import animation6 from "../assets/animations/6.json";
import animation7 from "../assets/animations/7.json";

const animations = [
  { id: 'anim-1', data: animation1 },
  { id: 'anim-2', data: animation2 },
  { id: 'anim-3', data: animation3 },
  { id: 'anim-4', data: animation4 },
  { id: 'anim-5', data: animation5 },
  { id: 'anim-6', data: animation6 },
  { id: 'anim-7', data: animation7 },
];

export default function Hero() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % animations.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero relative">
      {/* Text Content Section */}
      <div className="w-full lg:w-1/2 xl:pl-12 sm:pr-2 mt-8">
        <h1 className="animated-text1 text-5xl sm:text-6xl text-theme-white font-bold leading-tight mb-5">
          Your Global Technology Partner for Future Success
        </h1>

        <p className="animated-text2 font-light text-xl text-white-400 leading-relaxed mb-16">
          We provide developers & designers using the latest technologies to help
          you scale up your business.
        </p>

        <Fade direction="up" delay={500} triggerOnce>
          <Button
            href="/discuss-project"
            type="link"
            className="rgb-button flex w-80 h-18 items-center px-14 py-5 text-white text-xl rounded-lg shadow-2xl"
          >
            Get in Touch
            <svg
              className="ml-2 w-7 h-7 text-white animate-bounce-x"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </Button>
        </Fade>
      </div>

      {/* Animation Section */}
      <div className="flex pt-5 md:w-fit w-full justify-center items-center order-first md:order-first lg:order-last lg:w-1/2">
        <Fade direction="up" triggerOnce>
          <div className="animation-container">
            {animations.map((animation) => (
              <div
                key={animation.id}
                className={`absolute inset-0 transition-opacity duration-1000 ${
                  animation.id === animations[currentIndex].id 
                    ? 'opacity-100' 
                    : 'opacity-0'
                }`}
              >
                <Lottie
                  animationData={animation.data}
                  loop
                  autoplay
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                />
              </div>
            ))}
          </div>
        </Fade>
      </div>
    </section>
  );
}
